import { NotFoundError } from './../errors/not-found-error';
import { AppError } from './../errors/app-error';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BadRequest } from "../errors/bad-request";

@Injectable()
export class LocationService {

  private API_KEY = "eeef05cc7d4a141f6021a5dff56a98e4";
  private url: string = "http://api.ipstack.com/check?access_key=" + this.API_KEY + "&format=1";

  constructor(private _http: Http) { }

  getLocation() {
  /*  
    return this._http.get("https://freegeoip.net/json/")
      .map(response => response.json())
      .catch(this.handleError);
  */
    return this._http.get(this.url)
      .map(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    if (error.status === 400)
      return Observable.throw(new BadRequest(error.json()));

    if (error.status === 404)
      return Observable.throw(new NotFoundError(error.json()));

    return Observable.throw(new AppError(error));

  }

}



// WEBPACK FOOTER //
// ./src/app/services/location.service.ts